import {useContext} from "react";
import {LangContext} from "../lang/LangContext";

const useStrings = () => {
    const langContext = useContext(LangContext);
    return langContext.strings;
}

export default useStrings;